import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";
import { NewIDataUploadItem } from "../../interfaces/IDataUploadItem";

export const downloadFileRevision = async (
  revisionID?: string,
  requestID?: string,
  sharepointToken?: string
) => {
  const data = HttpService.post(
    ApiService.alesaForm.downloadFileRevision,
    JSON.stringify({
      RevisionID: revisionID,
      RequestID: requestID,
      SharepointToken: sharepointToken,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const requestAndReplyRevision = async (
  requestID?: string,
  binusianID?: string,
  revisionNote?: string,
  revisionDocument?: NewIDataUploadItem[],
  requestStatusID?: string,
  fromRole?: string,
  toRole?: string
) => {
  function convertData(inputData: NewIDataUploadItem[]) {
    return inputData.reduce((acc: any[], curr) => {
      const files = curr.files.map((file) => ({
        title: curr.title,
        fileType: curr.fileType,
        ...file,
      }));
      return [...acc, ...files];
    }, []);
  }
  const files = convertData(revisionDocument || []);
  const data = HttpService.post(
    ApiService.alesaForm.requestRevisionByEndUser,
    JSON.stringify({
      RequestID: requestID,
      BinusianID: binusianID,
      RevisionNote: revisionNote,
      ListRevisionDocument: files,
      RequestStatusID: requestStatusID,
      FromRole: fromRole, // id role end user
      ToRole: toRole, // id role legal relation
    })
  );
  const dataAPI = (await data).data;

  return dataAPI;
};
